import React, { useEffect, useState } from "react";
import Apiconnect from "../services/Apiconnect"; // adjust path if needed

const LeadList = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch lead list from API
  const fetchLeads = async () => {
    try {
      const response = await Apiconnect.postData("custlead_list", {}); 
      console.log(response)

      if (response?.data?.status === "1") {
        setLeads(response.data.data || []);
      } else {
        setLeads([]);
      }
    } catch (error) {
      console.error("Error fetching leads:", error);
      setLeads([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeads();
  }, []);

  // Helper for status badge


  return (
    <div className="container-fluid">
      <div className="card shadow-sm">
        <div className="card-body p-4">
          <h2 className="mb-4 fw-bold">Lead List</h2>

          {loading ? (
            <p>Loading...</p>
          ) : leads.length === 0 ? (
            <p className="text-muted">No leads available.</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped align-middle">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                   
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {leads.map((lead, index) => (
                    <tr key={lead.id}>
                      <td>{index + 1}</td>
                      <td>{lead.name}</td>
                      <td>{lead.email || "N/A"}</td>
                      <td>{lead.phone}</td>
                      
                      <td>{lead.created_on}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default LeadList;
